<div class="no-company-profile">

    <h2>Mehr Sichtbarkeit für dein Unternehmen</h2>

    <p>
        Der erste Eindruck zählt – auch online!<br>
        Erstelle dein eigenes Unternehmensprofil auf Zimmerer-Treffpunkt.<br>
        Für Handwerksbetriebe und kleine Dienstleister kostenlos.<br>
        Mehr Reichweite und zusätzliche Leistungen gewünscht? Hersteller, größere Dienstleister, Organisationen und Handwerksbetriebe können Partner werden.
    </p>

    <h2 class="second-headline">Starte jetzt und mach dein Unternehmen in der Branche sichtbar!</h2>

    <div class="grid-container">
        <ng-container *ngFor="let card of cards">
            <h3 class="grid-item grid-item-headline" [ngClass]="card.class" [innerHTML]="card.caption"></h3>

            <div class="grid-item grid-item-subcaption {{ card.class }}">
                {{ card.subcaption }}
            </div>

            <div class="grid-item grid-item-description" [ngClass]="card.class">
                {{card.description}}
            </div>

            <div class="grid-item grid-item-button" [ngClass]="card.class">
                <button class="orange-button button-to-bottom" (click)="card.function()">
                    {{card.buttontext}}
                </button>
            </div>

            <div class="grid-item grid-item-content" [ngClass]="card.class">
                <ul class="fa-ul">
                    <li *ngFor="let bullet of card.bullets">
                        <span class="bullet-icon">
                            <i class="fas fa-check" data-fa-transform="shrink-6"></i>
                        </span>

                        <span class="bullet-text">
                            {{ bullet }}
                        </span>
                    </li>
                </ul>
            </div>
        </ng-container>
    </div>
</div>
